<template>
  <v-container
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 my-2"
    >
      <processing-config
        title="Tipo de Câmera"
        v-model="currentProcessingAdvancedData.abCameraType"
        :items="abCameraTypeList"
        id="processing-step-advanced-camera-type"
        :error="abCameraTypeError"
        :disabled="inputDisabled"
      >
      </processing-config>
    </v-row>
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 my-2"
    >
      <processing-config
        title="Tipo de Processamento"
        v-model="currentProcessingAdvancedData.abProcessingTemplate"
        id="processing-step-advanced-template"
        :items="abProcessingTemplateList"
        :error="abProcessingTemplateError"
        :disabled="inputDisabled"
      >
      </processing-config>
    </v-row>
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 my-2"
    >
      <processing-config
        title="Log de Voo"
        v-model="currentProcessingAdvancedData.abGeoreferenceType"
        id="processing-step-advanced-georeference-type"
        :items="abGeoreferenceTypeList"
        :error="abGeoreferenceTypeError"
        :disabled="inputDisabled"
      >
      </processing-config>
    </v-row>
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 my-2"
    >
      <processing-config
        title="Pontos de Controle"
        v-model="currentProcessingAdvancedData.blGcp"
        id="processing-step-advanced-gcp"
        :items="blGcpList"
        :error="null"
        :disabled="inputDisabled"
        multiple
      >
        <template v-slot:top>
          <v-card-title class="subtitle-1 black--text font-weight-bold">
            Escolher EPSG:
          </v-card-title>
          <v-card-text>
            <transition name="text-fade" mode="out-in" appear>
              <div>
                <v-row>
                  <v-container>
                    <!-- List of EPSGS or a TextInput for EPSG -->
                    <v-row v-if="!manualEpsgDefinition && manualEpsgAllowed">
                      <v-autocomplete
                        v-model="currentProcessingAdvancedData.strGcpEpsg"
                        :items="strGcpEpsgList"
                        :error-messages="strGcpEpsgError"
                        :disabled="inputDisabled"
                        label="EPSG"
                        placeholder="Escolha o EPSG do seu GCPs"
                        prepend-icon="mdi-map-search"
                      ></v-autocomplete>
                    </v-row>
                    <v-row v-else class="ma-0" justify="start" align="center">
                      <v-col class="ma-0 pa-0 mb-1" cols="1">
                        <span class="body-2">EPSG:</span>
                      </v-col>
                      <v-col class="ma-0 pa-0 ml-1" cols="2">
                        <v-text-field
                          v-model="currentProcessingAdvancedData.strGcpEpsg"
                          :error-messages="strGcpEpsgError"
                          :disabled="inputDisabled"
                          v-mask="epsgMask"
                          style="width: 51px; text-align: center"
                          type="tel"
                          class="text-center"
                        />
                      </v-col>
                      <v-col>
                        <span> O EPSG apenas é válidos com <b>4 ou 5 digitos</b></span>
                      </v-col>
                    </v-row>

                    <v-row justify="end">
                      <a v-if="!inputDisabled && manualEpsgAllowed"
                        class="caption"
                        :ripple="false"
                        @click="manualEpsgDefinition = !manualEpsgDefinition"
                      >
                        {{ !manualEpsgDefinition ? "Não achei meu EPSG" : "Escolher EPSG de uma lista"}}
                      </a>
                    </v-row>
                  </v-container>
                </v-row>
              </div>
            </transition>
          </v-card-text>
          <v-divider/>

        </template>
      </processing-config>
    </v-row>
    <v-row
      align="center"
      justify="start"
      class="actions my-10"
    >
      <v-btn
        @click="LastStep"
        color="accent"
        outlined
      >
        Voltar
      </v-btn>
      <v-spacer/>
      <fragment
        v-if="mustShowEditButtons"
      >
        <fragment v-if="editMode">
          <!-- Botões para começar, salvar e cancelar a edição do mosaico -->
          <v-btn
            @click="cancelEditMode"
            :disabled="isUpdating"
            outlined
            color="error"
          >
            Cancelar Edição
          </v-btn>
          <v-btn
            @click="updateProcessingHandler"
            :loading="isUpdating"
            outlined
            color="success"
          >
            Salvar Edição
          </v-btn>
        </fragment>
        <fragment v-else>
          <v-btn
            @click="startEditMode"
            :disabled="this._processingIsReadOnly"
            outlined
            color="accent"
          >
            Editar
          </v-btn>
        </fragment>
      </fragment>
      <fragment
        v-else
      >
        <v-btn
          v-if="!this._processingIsReadOnly"
          @click="cancelProcessingCreation"
          :disabled="isCreating"
          color="error"
        >
          Cancelar
        </v-btn>
      </fragment>
      <v-btn
        @click="onNextClick"
        :loading="isLoading || isCreating || isUpdating"
        id="processing-step-advanced-next-btn"
        color="primary"
      >
        Próximo
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
  import {validationMixin} from "vuelidate"
  import required from "vuelidate/src/validators/required"
  import minLength from "vuelidate/src/validators/minLength"
  import maxLength from "vuelidate/src/validators/maxLength"
  import ProcessingConfig from "../../Helpers/Form/ProcessingConfig"
  import {AVAILABLE_EPSG, PROCESSING_OPTIONS, PROCESSING_STEPS} from "../../../helpers/processings/constants"
  import {mapActions, mapGetters} from "vuex"
  import {
    CLEAN_PROCESSING,
    DELETE_PROCESSING,
    GET_ID_PROCESSING,
    GET_PROCESSING_DATA,
    GET_PROCESSING_IS_ADVANCED_EDITABLE,
    GET_PROCESSING_IS_CREATED,
    GET_PROCESSING_IS_CREATING,
    GET_PROCESSING_IS_READ_ONLY,
    SET_ID_PROCESSING,
    UPDATE_PROCESSING,
  } from "../../../store/modules/processing"
  import {DIALOG_TYPES, DialogOptions} from "../../../helpers/dialogs"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../helpers/notify"
  import {cloneDeep, isEmpty, isEqual} from "lodash/lang"
  import {find, includes} from "lodash/collection"
  import {ProcessingStepperEventBus} from "../../../helpers/processings/events"

  const ProcessingLastStep = Symbol.for("ProcessingLastStep")
  const ProcessingNextStep = Symbol.for("ProcessingNextStep")

  export default {
    name: "ProcessingAdvanced",
    inject: {NextStep: ProcessingNextStep, LastStep: ProcessingLastStep},
    components: {ProcessingConfig},
    mixins: [validationMixin],
    data: () => ({
      isLoading: false,
      isCreating: false,
      isUpdating: false,
      isDeleting: false,

      editMode: false,
      manualEpsgDefinition: false,

      currentProcessingAdvancedData: {
        abCameraType: null,
        abProcessingTemplate: null,
        abGeoreferenceType: null,
        blGcp: false,
        strGcpEpsg: null,
      },

      lastProcessingAdvancedData: {
        abCameraType: null,
        abProcessingTemplate: null,
        abGeoreferenceType: null,
        blGcp: false,
        strGcpEpsg: null,
      },
    }),
    validations() {
      return {
        currentProcessingAdvancedData: {
          abCameraType: {
            required,
          },
          abProcessingTemplate: {
            required,
          },
          abGeoreferenceType: {
            required,
          },
          strGcpEpsg: {
            gcpEpsgRequired: (value, vm) => {
              return !vm.blGcp || Boolean(value)
            },
            minLength: minLength(4),
            maxLength: maxLength(5),
          },
        },
      }
    },
    methods: {
      onNextClick() {
        if (this._processingIsCreated) {
          this.NextStep()
          return
        }

        this.updateProcessingHandler(() => {
          this.NextStep()
        })
      },
      verifySubscriptionPlanConfig() {
        if (!includes(this.$subsMng.subscriptionPlanConfig["lst_allowed_flight_logs"], this.currentProcessingAdvancedData.abGeoreferenceType)) {
          const flightLogName = find(this.abGeoreferenceTypeList, item => isEqual(item.value, this.currentProcessingAdvancedData.abGeoreferenceType))
          this.$dialog(new DialogOptions({
            width: "650px",
            type: DIALOG_TYPES.BUSINESS_ONLY,
            content: `No seu plano atual não está incluso processamento com log de voo do tipo <br/><b>${flightLogName.name}</b>.<br/>
            Assine o plano Business e tenha todas as funcionalidades.`
          }))
          return false
        }
        if (this.currentProcessingAdvancedData.blGcp)
          if (!this.$subsMng.subscriptionPlanConfig["bl_allow_gcp"]) {
            this.$dialog(new DialogOptions({
              width: "650px",
              type: DIALOG_TYPES.BUSINESS_ONLY,
              content: `No seu plano atual não está incluso processamento com <br/><b>Pontos de Controle</b>.<br/>
              Assine o plano Business e tenha todas as funcionalidades.`
            }))
            return false
          }
        return true
      },
      updateProcessingHandler(callb = null) {
        this.$v.$touch()
        if (this.$v.$invalid) return

        if (!this.verifySubscriptionPlanConfig()) return

        if (this.currentProcessingAdvancedData.blGcp) {
          if (this.$subsMng.subscriptionPlanConfig["bl_charge_gcp"]) {
            this.$dialog(new DialogOptions({
              title: "Processamento com ponto de controle",
              content: "Usando ponto de controle é adicionado um valor de R$ 200,00 (duzentos reais) sobre o preço do processamento",
              type: DIALOG_TYPES.CONFIRM,
              onConfirm: () => {
                this.updateProcessing()
                  .then(() => {
                    if (callb instanceof Function) callb()
                  })
              }
            }))
            return
          }
        }

        this.updateProcessing()
          .then(() => {
            if (callb instanceof Function) callb()
          })
      },
      async updateProcessing() {
        let curEpsg = this.currentProcessingAdvancedData.strGcpEpsg
        if (curEpsg) {
          curEpsg = curEpsg.toLowerCase()
          if (!curEpsg.startsWith("epsg")) {
            curEpsg = `epsg:${curEpsg}`
          }
        }

        let processingData = {
          ab_camera_type: this.currentProcessingAdvancedData.abCameraType,
          ab_processing_template: this.currentProcessingAdvancedData.abProcessingTemplate,
          ab_georeference_type: this.currentProcessingAdvancedData.abGeoreferenceType,
          bl_gcp: this.currentProcessingAdvancedData.blGcp,
          str_gcp_epsg: curEpsg
        }
        await this._updateProcessing({
          idProcessing: this._idProcessing,
          processingData: processingData,
        }).then((res) => {
          this.setIdProcessing(res.data.data["id_processing"])
          this.editMode = false
          this.$notify(new NotificationOptions({
            message: "Suas modificações foram salvas com sucesso",
            type: NOTIFICATION_TYPES.SUCCESS,
          }))
        }).catch(() => {
          throw new Error("Error updating processing")
        }).finally(() => {
          this.isUpdating = false
        })
      },
      cancelProcessingCreation() {
        this.$dialog(new DialogOptions({
          title: "Tem certeza que deseja cancelar?",
          content: "Se você cancelar agora todos os dados do seu projeto serão perdidos",
          confirmText: "Cancelar",
          cancelText: "Voltar",
          type: DIALOG_TYPES.CONFIRM,
          onConfirm: this.cancelProcessingCreationHandler,
        }))
      },
      cancelProcessingCreationHandler() {
        this.isDeleting = true
        this._deleteProcessing(this._processingData["id_processing"])
          .then(() => {
            this.$router.push("/app/processing-list")
          })
          .finally(() => {
            this.isDeleting = false
          })
      },
      startEditMode() {
        this.editMode = true
        this.lastProcessingAdvancedData = cloneDeep(this.currentProcessingAdvancedData)
      },
      cancelEditMode() {
        this.editMode = false
        this.currentProcessingAdvancedData = this.lastProcessingAdvancedData
      },
      onStepEnter(step) {
        if (!isEqual(step, PROCESSING_STEPS.ADVANCED)) return
        if (!isEmpty(this._processingData)) {
          this.currentProcessingAdvancedData.abCameraType = this._processingData["ab_camera_type"]
          this.currentProcessingAdvancedData.abProcessingTemplate = this._processingData["ab_processing_template"]
          this.currentProcessingAdvancedData.abGeoreferenceType = this._processingData["ab_georeference_type"]
          this.currentProcessingAdvancedData.blGcp = this._processingData["bl_gcp"]

          let strGcpEpsg = this._processingData["str_gcp_epsg"]
          if (strGcpEpsg) {
            strGcpEpsg = strGcpEpsg.split(":", 2).slice(-1).pop()
            if (!includes(AVAILABLE_EPSG.map(o => o.epsg), strGcpEpsg)) {
              this.manualEpsgDefinition = true
            }
            this.currentProcessingAdvancedData.strGcpEpsg = strGcpEpsg
          }
        }
      },
      ...mapActions({
        setIdProcessing: SET_ID_PROCESSING,
        _updateProcessing: UPDATE_PROCESSING,
        _deleteProcessing: DELETE_PROCESSING,
        cleanProcessing: CLEAN_PROCESSING,
      }),
    },
    computed: {
      abCameraTypeError() {
        let error = null
        if (!this.$v.currentProcessingAdvancedData.abCameraType.$dirty) return error
        if (!this.$v.currentProcessingAdvancedData.abCameraType.required) error = "Esse campo é obrigatório"
        return error
      },
      abProcessingTemplateError() {
        let error = null
        if (!this.$v.currentProcessingAdvancedData.abProcessingTemplate.$dirty) return error
        if (!this.$v.currentProcessingAdvancedData.abProcessingTemplate.required) error = "Esse campo é obrigatório"
        return error
      },
      abGeoreferenceTypeError() {
        let error = null
        if (!this.$v.currentProcessingAdvancedData.abGeoreferenceType.$dirty) return error
        if (!this.$v.currentProcessingAdvancedData.abGeoreferenceType.required) error = "Esse campo é obrigatório"
        return error
      },
      strGcpEpsgError() {
        let error = null
        if (!this.$v.currentProcessingAdvancedData.strGcpEpsg.$dirty) return error
        if (!this.$v.currentProcessingAdvancedData.strGcpEpsg.gcpEpsgRequired) error = "Esse campo é obrigatório"
        if (!this.$v.currentProcessingAdvancedData.strGcpEpsg.minLength) error = "EPSG tem que ter no minimo 4"
        if (!this.$v.currentProcessingAdvancedData.strGcpEpsg.maxLength) error = "EPSG pode ter no máximo 5"
        return error
      },
      abCameraTypeList() {
        return PROCESSING_OPTIONS.abCameraType
      },
      abProcessingTemplateList() {
        if (!this.currentProcessingAdvancedData.abCameraType)
          return []
        return PROCESSING_OPTIONS.abProcessingTemplate[this.currentProcessingAdvancedData.abCameraType]
      },
      abGeoreferenceTypeList() {
        if (!this.currentProcessingAdvancedData.abCameraType)
          return []
        return PROCESSING_OPTIONS.abGeoreferenceType[this.currentProcessingAdvancedData.abCameraType]
      },
      blGcpList() {
        return PROCESSING_OPTIONS.blGcp
      },
      strGcpEpsgList() {
        return AVAILABLE_EPSG.map((epsgObj) => ({
          text: `${epsgObj.description} - EPSG:${epsgObj.epsg}`,
          value: epsgObj.epsg
        }))
      },
      inputDisabled() {
        if (this._processingIsReadOnly)
          return true
        return (!this.editMode && this._processingIsCreated)
      },
      mustShowEditButtons() {
        return this._processingIsAdvancedEditable && !this._processingIsReadOnly
      },
      manualEpsgAllowed() {
        return !this.$appMng.isIntl
      },
      epsgMask() {
        return ['#####']
      },
      ...mapGetters({
        _idProcessing: GET_ID_PROCESSING,
        _processingData: GET_PROCESSING_DATA,
        _processingIsReadOnly: GET_PROCESSING_IS_READ_ONLY,
        _processingIsCreated: GET_PROCESSING_IS_CREATED,
        _processingIsCreating: GET_PROCESSING_IS_CREATING,
        _processingIsAdvancedEditable: GET_PROCESSING_IS_ADVANCED_EDITABLE,
      }),
    },
    created() {
      ProcessingStepperEventBus.$on("step-change", this.onStepEnter)
    },
    watch: {
      abProcessingTemplateList() {
        if (!find(this.abProcessingTemplateList, ["value", this.currentProcessingAdvancedData.abProcessingTemplate]))
          this.currentProcessingAdvancedData.abProcessingTemplate = null
      },
      abGeoreferenceTypeList() {
        if (!find(this.abGeoreferenceTypeList, ["value", this.currentProcessingAdvancedData.abGeoreferenceType]))
          this.currentProcessingAdvancedData.abGeoreferenceType = null
      },
    },
  }
</script>

<style scoped lang="scss">
  .actions {
    .v-btn {
      margin: 0 5px;
    }
  }
</style>
